// extracted by mini-css-extract-plugin
export default {"label":"rightSetLocationModal_label__SsY+4"};